<div class="container maintenance-page h-100 d-flex align-items-center flex-column">
  <img class="logo" draggable="false" src="assets/images/nav-logo.png" />
  <div class="text-center maintenance-content">
    <div class="text-white icon material-icons mb-4">engineering</div>
    <h5 class="text-white mb-4">{{ 'maintenance.page.title' | translate }}</h5>
    <div
      class="text-white maintenance-text font-size-14 mb-4 text-center"
      [innerHTML]="'maintenance.page.details' | translate | markdownTranslate"
    ></div>
  </div>
</div>
